import { Routes } from '@angular/router';
import { TabsComponent } from './components/layout/tabs/tabs.component';

export const routes: Routes = [
  {
    path: 'tabs',
    component: TabsComponent,
    children: [
      {
        path: 'startseite',
        loadComponent: () => import('./pages/main-pages/home/home.page').then((m) => m.HomePage),
      },
      {
        path: 'suche',
        loadComponent: () => import('./pages/main-pages/search/search.page').then((m) => m.SearchPage),
      },
      {
        path: 'merkliste',
        loadComponent: () => import('./pages/main-pages/watch-list/watch-list.page').then((m) => m.WatchListPage),
      },
      {
        path: 'karrierevorschlage',
        loadComponent: () => import('./pages/main-pages/tree/tree.page').then((m) => m.TreePage),
      },
      {
        path: 'registrierung',
        loadComponent: () =>
          import('./pages/user-pages/user-registration/user-registration.page').then((m) => m.UserRegistrationPage),
      },
      {
        path: 'login',
        loadComponent: () => import('./pages/user-pages/user-login/user-login.page').then((m) => m.UserLoginPage),
      },
      {
        path: 'profil',
        loadComponent: () => import('./pages/user-pages/user-profile/user-profile.page').then((m) => m.UserProfilePage),
      },
      {
        path: 'datenschutz',
        loadComponent: () =>
          import('./pages/static-pages/data-protection/data-protection.page').then((m) => m.DataProtectionPage),
      },
      {
        path: 'impressum',
        loadComponent: () =>
          import('./pages/static-pages/legal-information/legal-information.page').then((m) => m.LegalInformationPage),
      },
      {
        path: 'nutzung',
        loadComponent: () =>
          import('./pages/static-pages/user-agreement/user-agreement.page').then((m) => m.UserAgreementPage),
      },
    ],
  },
  {
    path: '',
    redirectTo: 'tabs/startseite',
    pathMatch: 'full',
  },
  {
    path: 'kurs/:id',
    loadComponent: () => import('./pages/misc-pages/course/course.page').then((m) => m.CoursePage),
  },
];
